import { C } from '../constants';

function Btn({ children, onClick, disabled, variant = 'primary', style = {} }) {
  const s = {
    primary: { background: C.primary, color: C.white, border: `1px solid ${C.primary}` },
    outline: { background: 'transparent', color: C.primary, border: `1.5px solid ${C.primary}` },
    white: { background: C.white, color: C.primary, border: `1px solid ${C.white}` },
    ghost: { background: C.gray100, color: C.gray600, border: `1px solid ${C.gray200}` },
    danger: { background: C.danger, color: C.white, border: `1px solid ${C.danger}` },
  }[variant] || {};
  return (
    <button onClick={onClick} disabled={disabled} style={{
      ...s, borderRadius: 12, padding: '13px 20px', fontSize: 14, fontWeight: 700,
      cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
      outline: 'none', width: '100%', fontFamily: "'Plus Jakarta Sans', sans-serif",
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, ...style,
    }}>{children}</button>
  );
}

function Input({ label, value, onChange, type = 'text', placeholder = '', note = '', maxLength, disabled }) {
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <div style={{ fontSize: 12, fontWeight: 700, color: C.textMd, marginBottom: 6 }}>{label}</div>}
      <input type={type} value={value} onChange={e => onChange(e.target.value)}
        placeholder={placeholder} maxLength={maxLength} disabled={disabled}
        style={{
          width: '100%', padding: '11px 14px', borderRadius: 10,
          border: `1.5px solid ${C.gray200}`, fontSize: 14, color: C.text,
          background: disabled ? C.gray50 : C.white, outline: 'none', boxSizing: 'border-box',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}
        onFocus={e => { if (!disabled) e.target.style.borderColor = C.primary; }}
        onBlur={e => e.target.style.borderColor = C.gray200}
      />
      {note && <div style={{ fontSize: 11, color: C.textLt, marginTop: 4 }}>{note}</div>}
    </div>
  );
}

function Card({ children, style = {}, onClick }) {
  return (
    <div onClick={onClick} style={{
      background: C.white, borderRadius: 16, border: `1px solid ${C.gray200}`,
      padding: 16, boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
      cursor: onClick ? 'pointer' : 'default', ...style,
    }}>{children}</div>
  );
}

function Toast({ msg, type }) {
  if (!msg) return null;
  const bg = type === 'error' ? C.dangerLt : type === 'success' ? C.successLt : C.primaryLt;
  const color = type === 'error' ? C.danger : type === 'success' ? C.success : C.primary;
  return (
    <div style={{
      position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
      background: bg, color, borderRadius: 10, padding: '12px 20px',
      fontSize: 13, fontWeight: 700, zIndex: 9999, maxWidth: 340,
      textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '90%',
    }}>{msg}</div>
  );
}

function NivelBadge({ nivel }) {
  const map = {
    Bronce:  { bg: '#FEF3C7', color: '#92400E', border: '#F59E0B' },
    Plata:   { bg: '#F3F4F6', color: '#374151', border: '#9CA3AF' },
    Oro:     { bg: '#FEF9C3', color: '#854D0E', border: '#EAB308' },
    Platino: { bg: '#DBEAFE', color: '#1E40AF', border: '#3B82F6' },
    Black:   { bg: '#1F2937', color: '#F9FAFB', border: '#374151' },
  };
  const s = map[nivel] || map.Bronce;
  return (
    <span style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}`, borderRadius: 99, padding: '2px 10px', fontSize: 11, fontWeight: 700 }}>{nivel}</span>
  );
}

function ProximamenteBadge() {
  return (
    <span style={{ background: C.warningLt, color: C.warning, border: `1px solid #FDE68A`, borderRadius: 99, padding: '2px 8px', fontSize: 10, fontWeight: 700 }}>Próximamente</span>
  );
}

function MetodoCard({ icon, titulo, descripcion, seleccionado, onClick, proximamente, color }) {
  const borderColor = seleccionado ? (color || C.primary) : C.gray200;
  const bg = seleccionado ? (color ? `${color}10` : C.primaryLt) : C.white;
  return (
    <div onClick={proximamente ? null : onClick} style={{
      border: `2px solid ${borderColor}`, borderRadius: 14, padding: '14px 16px',
      background: bg, cursor: proximamente ? 'default' : 'pointer', marginBottom: 10,
      opacity: proximamente ? 0.7 : 1, transition: 'all 0.15s',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ fontSize: 28, flexShrink: 0 }}>{icon}</div>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
            <span style={{ fontSize: 14, fontWeight: 800, color: C.text }}>{titulo}</span>
            {proximamente && <ProximamenteBadge />}
          </div>
          <div style={{ fontSize: 12, color: C.textMd, lineHeight: 1.5 }}>{descripcion}</div>
        </div>
        <div style={{
          width: 20, height: 20, borderRadius: '50%', border: `2px solid ${seleccionado ? (color || C.primary) : C.gray300}`,
          background: seleccionado ? (color || C.primary) : 'transparent', flexShrink: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {seleccionado && <div style={{ width: 8, height: 8, borderRadius: '50%', background: C.white }} />}
        </div>
      </div>
    </div>
  );
}

function StepIndicator({ step, total = 3 }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 24 }}>
      {Array.from({ length: total }, (_, i) => i + 1).map(n => (
        <div key={n} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{
            width: 28, height: 28, borderRadius: '50%', fontSize: 12, fontWeight: 800,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: step >= n ? C.primary : C.gray200,
            color: step >= n ? C.white : C.textLt,
          }}>{step > n ? '✓' : n}</div>
          {n < total && <div style={{ width: 24, height: 2, background: step > n ? C.primary : C.gray200, borderRadius: 99 }} />}
        </div>
      ))}
    </div>
  );
}

export { Btn, Input, Card, Toast, NivelBadge, ProximamenteBadge, MetodoCard, StepIndicator };
